import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { LoadingProvider } from '../../providers/loading';
import { ImageProvider } from '../../providers/image';
import { AlertProvider } from '../../providers/alert';
import { UserProvider } from '../../providers/user';
import { Camera } from '@ionic-native/camera';
import { AddMembersPage } from '../add-members/add-members';
import { UserInfoPage } from '../user-info/user-info';

@Component({
  selector: 'page-group-info',
  templateUrl: 'group-info.html'
})
export class GroupInfoPage {
  private groupId: any;
  private group: any;
  private groupMembers: any;
  private alert: any;
  private user: any;
  private myUserId: any;
  private subscription: any;
  private adminRadioList: any;
  // GroupInfoPage
  // This is the page where the user can view group information, change group information, add members, and leave/delete group.
  constructor(public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider,
    public loadingProvider: LoadingProvider, public modalCtrl: ModalController, public alertCtrl: AlertController,
    public alertProvider: AlertProvider, public imageProvider: ImageProvider, public camera: Camera, public userProvider: UserProvider) { }

  ionViewDidLoad() {
    // Initialize
    this.groupId = this.navParams.get('groupId');
    this.myUserId = this.userProvider.getUserID();
    console.log(this.groupId);

    // Get group details.
    this.subscription = this.dataProvider.getGroup(this.groupId).snapshotChanges().subscribe((groupRes) => {
      let group = { $key: groupRes.key, ... groupRes.payload.val()};
      console.log(group);
      if (group != null) {
        this.loadingProvider.show();
        this.group = group;
        if (group.members) {
          group.members.forEach((memberId) => {
            this.dataProvider.getUser(memberId).snapshotChanges().subscribe((member) => {
              if(member.key != null){
                member = { $key: member.key, ... member.payload.val()};
                this.addUpdateOrRemoveMember(member);
              }
            });
          });
        }
        this.loadingProvider.hide();
      } else {
        // Group is deleted, go back.
        this.navCtrl.popToRoot();
      }
    });

    // Get user details.
    this.dataProvider.getCurrentUser().snapshotChanges().subscribe((user) => {
      this.user = {$key: user.key, ...user.payload.val()};
    });
  }

  // Delete subscription.
  // ionViewDidLeave() {
  //   if(this.deleteSubscription)
  //
  // }

  // Check if user exists in the group then add/update user.
  // If the user has already left the group, remove user from the list.
  addUpdateOrRemoveMember(member) {
    console.log(member);
    if (this.group) {
      if (this.group.members.indexOf(member.$key) > -1) {
        // User exists in the group.
        if (!this.groupMembers) {
          this.groupMembers = [member];
        } else {
          var index = -1;
          for (var i = 0; i < this.groupMembers.length; i++) {
            if (this.groupMembers[i].$key == member.$key) {
              index = i;
            }
          }
          // Add/Update User.
          if (index > -1) {
            this.groupMembers[index] = member;
          } else {
            this.groupMembers.push(member);
          }
        }
      } else {
        // User already left the group, remove member from list.
        var index1 = -1;
        for (var j = 0; j < this.groupMembers.length; j++) {
          if (this.groupMembers[j].$key == member.$key) {
            index1 = j;
          }
        }
        if (index1 > -1) {
          this.groupMembers.splice(index1, 1);
        }
      }
    }

  }

  // View user info.
  viewUser(userId, username) {
      if(this.group.admin == this.myUserId) {
          if (this.userProvider.getUserID() != userId) {
              this.alertCtrl.create({
                  title: 'Admin',
                  message: 'Soll der Benutzer <b>' + username + '</b> aus der Gruppe entfernt werden?',
                  buttons: [
                      {
                          text: 'Abbrechen',
                          handler: data => {
                          }
                      },
                      {
                          text: 'Aus der Gruppe Entfernen',
                          handler: () => {
                              this.group.members.splice(this.group.members.indexOf(userId), 1);

                              this.dataProvider.getGroup(this.groupId).update({
                                  members: this.group.members,
                                  messages: this.group.messages
                              }).then((success) => {
                                  // Remove group from user's group list.

                              }).catch((error) => {

                              });
                          }
                      }
                  ]
              }).present();
          }
      } else {
          if (this.userProvider.getUserID() != userId) {
              this.navCtrl.push(UserInfoPage, {userId: userId});
          }
      }

  }
  
  // Enlarge group image.
  enlargeImage(img) {
    let imageModal = this.modalCtrl.create("ImageModalPage", { img: img });
    imageModal.present();
  }

  // Change group name.
  setName() {
    this.alert = this.alertCtrl.create({
      title: 'Gruppenname Ändern',
      message: "Bitte gebe einen neuen Namen an.",
      inputs: [
        {
          name: 'name',
          placeholder: 'Gruppenname',
          value: this.group.name
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Speichern',
          handler: data => {
            let name = data["name"];
            if (this.group.name != name) {
              this.loadingProvider.show();
              // Add system message.
              this.group.messages.push({
                date: new Date().toString(),
                sender: this.user.$key,
                type: 'system',
                message: this.user.name + ' hat die Gruppe unbenannt: ' + name + '.',
                icon: 'md-create'
              });
              // Update group on database.
              this.dataProvider.getGroup(this.groupId).update({
                name: name,
                messages: this.group.messages
              }).then((success) => {
                this.loadingProvider.hide();
                this.alertProvider.showGroupUpdatedMessage();
              }).catch((error) => {
                this.loadingProvider.hide();
                this.alertProvider.showErrorMessage('group/error-update-group');
              });
            }
          }
        }
      ]
    }).present();
  }

  // Change group image, the user is asked if they want to take a photo or choose from gallery.
  setPhoto() {
    this.alert = this.alertCtrl.create({
      title: 'Gruppenbild Ändern',
      message: 'Gruppenbild ändern?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Aus Galerie wählen',
          handler: () => {
            this.loadingProvider.show();
            // Upload photo and set to group photo, afterwards, return the group object as promise.
            this.imageProvider.setGroupPhotoPromise(this.group, this.camera.PictureSourceType.PHOTOLIBRARY).then((group) => {
              // Add system message.
              this.group.messages.push({
                date: new Date().toString(),
                sender: this.user.$key,
                type: 'system',
                message: this.user.name + ' hat das Gruppenbild geändert.',
                icon: 'ios-camera'
              });
              // Update group image on database.
              this.dataProvider.getGroup(this.groupId).update({
                img: group.img,
                messages: this.group.messages
              }).then((success) => {
                this.loadingProvider.hide();
                this.alertProvider.showGroupUpdatedMessage();
              }).catch((error) => {
                this.loadingProvider.hide();
                this.alertProvider.showErrorMessage('group/error-update-group');
              });
            });
          }
        },
        {
          text: 'Kamera',
          handler: () => {
            this.loadingProvider.show();
            // Upload photo and set to group photo, afterwwards, return the group object as promise.
            this.imageProvider.setGroupPhotoPromise(this.group, this.camera.PictureSourceType.CAMERA).then((group) => {
              // Add system message.
              this.group.messages.push({
                date: new Date().toString(),
                sender: this.user.$key,
                type: 'system',
                message: this.user.name + ' hat das Gruppenbild geändert.',
                icon: 'ios-camera'
              });
              // Update group image on database.
              this.dataProvider.getGroup(this.groupId).update({
                img: group.img,
                messages: this.group.messages
              }).then((success) => {
                this.loadingProvider.hide();
                this.alertProvider.showGroupUpdatedMessage();
              }).catch((error) => {
                this.loadingProvider.hide();
                this.alertProvider.showErrorMessage('group/error-update-group');
              });
            });
          }
        }
      ]
    }).present();
  }

  // Change group description.
  setDescription() {
    this.alert = this.alertCtrl.create({
      title: 'Gruppenbeschreibung Ändern',
      message: "Bitte schreibe eine neue Gruppenbeschreibung.",
      inputs: [
        {
          name: 'description',
          placeholder: 'Beschreibung',
          value: this.group.description
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Speichern',
          handler: data => {
            let description = data["description"];
            if (this.group.description != description) {
              this.loadingProvider.show();
              // Add system message.
              this.group.messages.push({
                date: new Date().toString(),
                sender: this.user.$key,
                type: 'system',
                message: this.user.name + ' hat die Gruppenbeschreibung geändert.',
                icon: 'md-clipboard'
              });
              // Update group on database.
              this.dataProvider.getGroup(this.groupId).update({
                description: description,
                messages: this.group.messages
              }).then((success) => {
                this.loadingProvider.hide();
                this.alertProvider.showGroupUpdatedMessage();
              }).catch((error) => {
                this.loadingProvider.hide();
                this.alertProvider.showErrorMessage('group/error-update-group');
              });
            }
          }
        }
      ]
    }).present();
  }

  chooseNewAdmin(leaveAfter: boolean = false) {
      this.adminRadioList = [];

      this.groupMembers.forEach((member) => {
          if(member.$key !=  this.myUserId) {
              let m = {
                  type: 'radio',
                  label: member.name+' '+member.surname,
                  value: member.$key
              }
              this.adminRadioList.push(m);
          }
      });

      let alert = this.alertCtrl.create({
          title: 'Wähle einen neuen Admin',
          inputs: this.adminRadioList,
          buttons: [
              {
                  text: 'Abbrechen',
                  role: 'cancel',
                  handler: () => {
                      console.log('Cancel clicked');
                  }
              },
              {
                  text: 'OK',
                  handler: (userID:string) => {
                      this.loadingProvider.show();
                      this.dataProvider.getGroup(this.groupId).update({
                          admin: userID

                      }).then((success) => {
                          this.dataProvider.getUser(userID).snapshotChanges().subscribe((member) => {
                              let newAdmin = member.payload.val();

                              this.loadingProvider.hide();

                              let leaveMessage: string = '';

                              if(leaveAfter == false) {
                                  leaveMessage = this.user.name +' '+ this.user.surname +' hat seine Administration an '+newAdmin.name+' '+newAdmin.surname+' abgegeben.';
                              } else {
                                  leaveMessage = 'Administrator '+this.user.name + this.user.surname +' hat die Gruppe verlassen und hat den Nachfolger '+newAdmin.name+' '+newAdmin.surname+' als Administrator gewählt.';
                              }

                              this.group.messages.push({
                                  date: new Date().toString(),
                                  sender: this.user.$key,
                                  type: 'system',
                                  message: leaveMessage,
                                  icon: 'md-log-out'
                              });
                              // Update group on database.
                              this.dataProvider.getGroup(this.groupId).update({
                                  messages: this.group.messages
                              }).then((success) => {
                                  if(leaveAfter == false) {
                                      setTimeout(() => {
                                          this.loadingProvider.hide();
                                          this.navCtrl.pop();
                                      }, 300);
                                  } else {

                                  }
                              }).catch((error) => {

                              });
                          });
                      }).catch((error) => {
                          this.loadingProvider.hide();
                          this.alertProvider.showErrorMessage('group/error-update-group');
                      });
                  }
              }
          ]
      });
      alert.present();
  }

  // Leave group.
  leaveGroup() {
    let groupMessage: string = '';
    if(this.myUserId == this.group.admin) {
      groupMessage = 'Gruppe verlassen? <br><br>Es muss vorher ein neuer Admin als Nachfolger für die Gruppe festgelegt werden.';
    } else {
      groupMessage = 'Gruppe verlassen?';
    }
    this.alert = this.alertCtrl.create({
      title: 'Austreten bestätigen',
      message: groupMessage,
      buttons: [
        {
          text: 'Abbrechen'
        },
        {
          text: 'Verlassen',
          handler: data => {
            if(this.myUserId != this.group.admin) {
                this.loadingProvider.show();
                // Remove member from group.
                this.group.members.splice(this.group.members.indexOf(this.user.$key), 1);
                // Add system message.
                /*this.group.messages.push({
                    date: new Date().toString(),
                    sender: this.user.$key,
                    type: 'system',
                    message: this.user.name + ' hat die Gruppe verlassen.',
                    icon: 'md-log-out'
                });*/
                // Update group on database.
                this.dataProvider.getGroup(this.groupId).update({
                    members: this.group.members,
                    messages: this.group.messages
                }).then((success) => {
                    // Remove group from user's group list.

                }).catch((error) => {
                    this.alertProvider.showErrorMessage('group/error-leave-group');
                });
            } else {
              this.chooseNewAdmin(true);
            }

          }
        }
      ]
    }).present();
  }

  // Delete group.
  deleteGroup() {
    this.alert = this.alertCtrl.create({
      title: 'Löschen bestätigen',
      message: 'Gruppe löschen?',
      buttons: [
        {
          text: 'Abbrechen'
        },
        {
          text: 'Löschen',
          handler: data => {
            let group = JSON.parse(JSON.stringify(this.group));
            console.log(group);
            // Delete all images of image messages.
            group.messages.forEach((message) => {
              if (message.type == 'image') {
                console.log("Delete: " + message.url + " of " + group.$key);
                this.imageProvider.deleteGroupImageFile(group.$key, message.url);
              }
            });
            

            // Delete group image.
            console.log("Delete: " + group.img);
            this.imageProvider.deleteImageFile(group.img);
            this.navCtrl.popToRoot();
          }
        }
      ]
    }).present();
  }

  // Add members.
  addMembers() {
    this.navCtrl.push(AddMembersPage, { groupId: this.groupId });
  }
}




// WEBPACK FOOTER //
// ./src/pages/group-info/group-info.ts